// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1XvG7","dragIcon":"SortableItem_dragIcon__lolDw","disabled":"SortableItem_disabled__2wyFE"};